<template>
  <div>
    <div
      v-if="isActive"
      class="click-area"
      @click="toggleDropdown"
    />
    <div class="category-filter">
      <span
        v-if="value.length && !isActive"
        class="clear"
        @click="selectItem('_clear_')"
      >clear</span>
      <span
        v-if="isActive"
        class="close"
        @click="toggleDropdown()"
      >X
      </span>

      <ul
        id="container"
        :class="{active: isActive}"
        class="dropdown"
      >
        <li>
          <template v-if="value != ''">
            <div
              :key="1"
              class="selected-filter-tags"
              @click="toggleDropdown()"
            >
              <span
                v-for="(name, index) in value"
                :key="index"
                class="filter-tag"
              >
                {{ name }}
              </span>
            </div>
          </template>
          <template v-else>
            <div @click="toggleDropdown()">
              Select Options
            </div>
          </template>
        </li>
        <li
          v-for="(item, index) in items"
          :key="index"
          :class="{active: value.includes(item) }"
          @click="selectItem(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'select-dropdown',
  props: {
    'items': {
      type: Array,
      required: true
    },
    'value': {
      type: Array,
      required: true
    },
    'name': {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isActive: false,
      selectedItem: ''
    }
  },
  created() {
    this.$eventHub.$on('hideCatalogFilters', (event) => {
      if (this._uid !== event) this.isActive = false
    })
  },
  methods: {
    selectItem: function(item) {
      this.selectedItem = item

      if (item === '') {
        this.isActive = true
      }
      this.$emit('input', item)
    },
    toggleDropdown() {
      this.isActive = !this.isActive
      this.$eventHub.$emit('hideCatalogFilters', this._uid)
      if (!this.isActive) {
        this.$el.querySelector('#container').scrollTop = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@scss/custom.scss';

.click-area {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  //z-index: 998;
  z-index:3;
}

    .category-filter {
      position: relative;
      .selected-filter-tags {
        padding-right: 3em;
      }
      .close {
        //z-index: 1000;
        z-index:5;
        position: absolute;
        top: -1.5em;
        right: 0;
        color: var(--main-primary-dark);
        font-size: 1.5em;
        font-weight: 200;
      }
      .clear {
        //z-index: 1001;
        z-index:6;
        position: absolute;
        right: 0.25em;
        background: var(--main-active-background-color);
        color: var(--main-active-text-color);
        padding: 0 0.5em;
        display: block;
        height: 2em;
        line-height: 2em;
        top: 0.25em;
        border-radius: 3px;
        cursor: pointer;
        transition: var(--main-transition);
        @include hover-focus {
            background:var(--main-active-hover-background-color);
            color:var(--main-active-hover-text-color);
        }

      }
      ul.dropdown {
        //z-index: 999;
        z-index:4;
        list-style: none;
        background: var(--main-white);
        height: 2.5em;
        line-height: 2.25em;
        overflow: hidden;
        transition: ease-in-out all .2s;
        color: var(--main-text);
        position: absolute;
        width: 100%;
        padding: 0;

        &.active {
          height: 15em;
          overflow-y: auto;
          width: 100%;
          box-shadow: var(--box-shadow-dropdown);
          //z-index: 1000;
          z-index:7;
          .clear {
            display: none;
          }
        }

        li {
          z-index:5;
          margin: 0;
          padding: .25rem 1rem;
          cursor: pointer;
          position: relative;

          .filter-tag {
            background-color:white;
            border: 1px solid var(--main-border-color);
            padding: .2em .5em;
            margin-right:.5rem;
            border-radius: 1em;
          }
          @include transition(background .3s, color .3s);
          @include hover-focus{
            background: var(--main-hover-background-color);
            color: var(--main-hover-text-color);
          }
          &.active {
            background: var(--main-active-background-color);
            color:var(--main-active-text-color);
          @include hover-focus{
            background:var(--main-active-hover-background-color);
            color:var(--main-active-hover-text-color)
          }
          }
        }
      }
    }
</style>
